import { ConstructionSiteInterface } from '@/types'

export const getConstructionSiteUpdateRequestBody = (
  constructionSite: ConstructionSiteInterface['constructionSiteModel'],
  isMain: boolean,
  isActive: boolean
) => {
  return {
    description: constructionSite.description,
    address: constructionSite.address,
    ownerName: constructionSite.ownerName,
    ownerPhoneNumber: constructionSite.ownerPhoneNumber,
    isMain: isMain,
    isActive: isActive,
    isStore: false,
  }
}

export const getShortenConstructionSiteProperty = (
  property: string,
  length: number
) => {
  return property.length > length ? property.slice(0, length) + '...' : property
}
